import { createContext } from 'react';

import { type LinkVariants } from '../utils/variants/link';

/**
 * Defaults for every inline Link (`type="link"`) rendered inside a surface with its own text colour.
 * A surface such as Alert provides `{ tone: 'inherit', underline: 'always' }`
 * so its links match its text and stay distinguishable from it. A `tone` or
 * `underline` set on the Link itself always wins.
 */
const LinkDefaultsContext = createContext<
  Pick<LinkVariants, 'tone' | 'underline'>
>({});

export { LinkDefaultsContext };
